/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiCaller } from "../../wire/ApiCaller";
import type {
  GetUserMappingSettingsResponse,
  GetUserMappingsRequest,
  GetUserMappingsResponse,
  NoData,
  SetUserMappingSettingsRequest,
} from "./models";
import {
  getUserMappingSettingsResponseSchema,
  getUserMappingsResponseSchema,
  noDataSchema,
} from "./schemas";

export class AlmsyncUserMappingsApiClient {
  constructor(private caller: ApiCaller) {}

  async getUserMappings(
    payload: GetUserMappingsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<GetUserMappingsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.user_mappings.connections.${connectionId}.get",
        variables: { connectionId: String(connectionId) },
      },
      "getUserMappings",
      payload,
      { schema: getUserMappingsResponseSchema, timeout },
    );
  }

  async getSettings(
    connectionId: string,
    timeout?: number,
  ): Promise<GetUserMappingSettingsResponse> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.user_mappings.connections.${connectionId}.settings.get",
        variables: { connectionId: String(connectionId) },
      },
      "getSettings",
      {},
      { schema: getUserMappingSettingsResponseSchema, timeout },
    );
  }

  async setSettings(
    payload: SetUserMappingSettingsRequest,
    connectionId: string,
    timeout?: number,
  ): Promise<NoData> {
    return await this.caller.request(
      {
        template:
          "pip.${companyId}.${userId}.${role}.rpc.almsync.v1.user_mappings.connections.${connectionId}.settings.set",
        variables: { connectionId: String(connectionId) },
      },
      "setSettings",
      payload,
      { schema: noDataSchema, timeout },
    );
  }
}
